export default __webpack_public_path__ + "static/media/JUV-BNB.a19eed13.svg";